import MonitoringQueueEntrySearchDetailsTable from './MonitoringQueueEntrySearchDetailsTable';

export default MonitoringQueueEntrySearchDetailsTable;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-details-form/table/index.js